import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { ReturnUrlService } from '../services/core/return-url.service';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const returnUrlService = inject(ReturnUrlService);

  if (auth.isAuthenticated()) {
    return true;
  }

  try {
    returnUrlService.set(state?.url || '/');
  } catch { }

  router.navigate(['/auth/login'], {
    queryParams: { returnUrl: state?.url || '/' },
  });

  return false;
};
